export default __webpack_public_path__ + "static/media/base.e7484b7e.png";